import { render, staticRenderFns } from "./params_set.vue?vue&type=template&id=b623f934&scoped=true"
import script from "./params_set.vue?vue&type=script&lang=js"
export * from "./params_set.vue?vue&type=script&lang=js"
import style0 from "./params_set.vue?vue&type=style&index=0&id=b623f934&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b623f934",
  null
  
)

export default component.exports